import { AppData, Log, Utils } from '@lightningjs/sdk'
import { PlatformBase } from './platform-base'
import { getDeviceIp, getSiteConfig, initSecurityToken } from '../lib/models/data-service'
import { KeyCodes } from '../lib/key-codes'
import { Lifecycle, Metrics, Device, Discovery, Parameters, Advertising } from '@firebolt-js/sdk'
import * as _FIREBOLT from '@firebolt-js/sdk'
import Router from '@lightningjs/sdk/src/Router'
import { AppSetup } from '../lib/app-setup'
import { PLATFORM } from '../lib/enum'
import { Platform } from './platform'
import errorHandler from '../lib/error'
import { resolve } from 'path'
import { Helper } from '../lib/helper'
import { Logger } from '../lib/logger'

export class PlatformComcast extends PlatformBase {

  lifecycleListinerId!: Promise<number>
  networkListinerId!: Promise<number>
  adFrameworkConfig: any;
  _params!: Parameters.AppInitialization;
  _advertisingId: any;

  constructor() {
    super()
    window._FIREBOLT = _FIREBOLT
    window.Lifecycle = Lifecycle
    window.Metrics = Metrics
    window.Device = Device
    window.Discovery = Discovery
    window.Parameters = Parameters
    this._setKeys()
    this.keyMap = {
      413: 'Stop',
      415: 'Play',
      19: 'Pause',
      179: 'PlayPause',
      227: 'Rewind',
      228: 'Forward',
      33: 'Next',
      34: 'Previous',
      27: 'Exit',
      8: 'Back',
      73: 'Info'
    }
  }

  override setKeyMappings(appSettings: any) {
    appSettings.keys = this.keyMap
  }

  override _setKeys() {
    KeyCodes.KEY_STOP = 413;
    KeyCodes.KEY_PLAY = 415;
    KeyCodes.KEY_PAUSE = 19;
    KeyCodes.KEY_PLAYPAUSE = 179;
    KeyCodes.KEY_REWIND = 227;
    KeyCodes.KEY_FORWARD = 228;
    KeyCodes.KEY_NEXT = 33;
    KeyCodes.KEY_PREVIOUS = 34;
    KeyCodes.KEY_BACK = 461;
    KeyCodes.KEY_PLAYPAUSE = 179;
    KeyCodes.KEY_INFO = 73;
    KeyCodes.KEY_EXIT = 69;
    KeyCodes.KEY_HOME = 77;
  }

  override async initialize(): Promise<boolean> {
    Log.info('PlatformBase:', typeof this)
    const { appConfig } = AppData as AppSetup;
    appConfig.logUrl = 'https://logcomcast.ifood.tv/'    
    
    this._siteConfig = await getSiteConfig()
    Log.info('PlatformBase: siteConfig: ', this._siteConfig)    
    appConfig?.adSdkToUse = 'freewheel' //default value to be set for adSdkToUse other changes will be taken in teh code.
    Helper.getSiteConfigInfo(this._siteConfig)

    if(appConfig.enableSecurityToken){
      appConfig?.apiVersion = "sv9.0";
      var securityToken = Helper.getCookie("_token");
      if (securityToken) {
        appConfig.securityToken = securityToken;
      } else {
        var securityTokenAPIResp = await initSecurityToken();
        appConfig.securityToken = securityTokenAPIResp.securityToken;
        Helper.setGeneralCookie("_token", appConfig.securityToken, 1);
      }
    }

    const promise: Promise<boolean> = new Promise((resolve, reject) => {
      const deviceInfos = []
      deviceInfos.push(Device.uid())
      deviceInfos.push(Device.sku())
      deviceInfos.push(Device.distributor())
      deviceInfos.push(Parameters.initialization())
      deviceInfos.push(Advertising.advertisingId())
      this._setupLifecycleEvents()
      this._setUpNetworkListener()
      this._setUpNavigationIntent()
      errorHandler.initErrorReporting()
      /*Promise.all(deviceInfos)
        .then((values) => {
          const { appConfig } = AppData as AppSetup
          this._deviceId = values[0]!
          this.isDevice = true
          this._fullModel = values[1]!
          this._partnerId = values[2]!
          this._params = values[3]!
          if (this._partnerId == 'xglobal') {
            appConfig?.setPlatformId(PLATFORM.PLATCO)
          }
          if (appConfig.consoleDebugLog == true && appConfig?.testDeviceId !== '') {
            this._deviceId = appConfig?.testDeviceId
          }
          Log.info('DeviceInfo: uid: ', this._deviceId)
          Log.info('DeviceInfo: model: ', this._fullModel)
          Log.info('DeviceInfo: distributor: ', values[2]!)
          Log.info('DeviceInfo: _params: ', values[3]!)
          resolve(true)
        })*/
        /** New Changes for XUMO Lauch fix - START */
        this.logAllDeviceParams()
        const values = [];        
        deviceInfos.forEach((promise, index) => {
          promise
            .then(result => {
              values[index] = result;
              Log.info('DeviceInfo : then ', index + 1);
              const { appConfig } = AppData as AppSetup
              this._deviceId = values[0]!
              this.isDevice = true
              this._fullModel = values[1]!
              this._partnerId = values[2]!
              this._params = values[3]!
              this._advertisingId = values[4]!              
              const  _advertisingId = values[4]!
              if(_advertisingId){
                this.setIFADetails(_advertisingId)              
              }
              if (this._partnerId == 'xglobal') {
                appConfig?.setPlatformId(PLATFORM.PLATCO)
              }
              // if (appConfig?.testDeviceId !== '') { //remove this condition "appConfig.consoleDebugLog == true"
              //   this._deviceId = appConfig?.testDeviceId
              // }              
              if(this.canResolve(values, deviceInfos)) {
                Log.info('DeviceInfo: uid: ', this._deviceId)
                Log.info('DeviceInfo: model: ', this._fullModel)
                Log.info('DeviceInfo: distributor: ', this._partnerId)
                Log.info('DeviceInfo: _params: ', this._params)
                Log.info('DeviceInfo: _advertisingId: ', this._advertisingId)                            
                resolve(true)
              }
            })
            .catch(error => {
              Log.error('DeviceInfo : error ', index + 1, 'error:', error.message);
              values[index] = '';              
              if(this.canResolve(values, deviceInfos)) {
                Log.info('DeviceInfo: uid: ', this._deviceId)
                Log.info('DeviceInfo: model: ', this._fullModel)
                Log.info('DeviceInfo: distributor: ', this._partnerId)
                Log.info('DeviceInfo: _params: ', this._params)
                Log.info('DeviceInfo: _advertisingId: ', this._advertisingId)              
                resolve(true)
              }
            });
        });
        /** New Changes for XUMO Lauch fix - END */
    })
    return promise
  }

  canResolve = (values: any, arr: any) => {
    for (var i = 0; i < arr.length; i++) {
      if (values[i] == undefined) {
        return false;
      }
    }
    return true;
  }

  _updateNetworkState(data) {
    if (!window.networkState) {
      window.networkState = []
    }
    window.networkState.push(data)
    Log.info('PlatformBase: NetworkStateChanged', data)
    this.networkManager.setNetworkState(data)
  }

  override _setUpNetworkListener() {
    //this.networkListinerId = Device.listen('networkChanged', this._updateNetworkState)
    window.addEventListener('offline', () => {
      Log.info('device is offline');
      this._updateNetworkState(false)
    })
    window.addEventListener('online', () => {
      Log.info('device is online');
      this._updateNetworkState(true)
    })
  }

  getDeviceApi(apiName, api, responseType) {
    return new Promise((resolve, reject) => {
      api()
        .then((response:any) => {
          let resp = `${apiName}=`
          if(responseType == 'json') {
            const results = []
            let isEmpty = true
            for (const [key, value] of Object.entries(response)) {
              let val = value
              isEmpty = false
              if(value && value.readable) {
                val = value.readable
              }
              results.push(`${key}:${val}`)
            }
            if(!isEmpty) {
              resp+= results.join(',')
            }
          } else if(responseType == 'array') {
            resp+= response.join(',')
          } else if(responseType == 'string') {
            resp+=(response instanceof Object) ? '' : response
          }
          resolve(resp)
        })
        .catch((error) => {
          resolve(`${apiName}=apiError`)
        })
    })
  }

  logAllDeviceParams() {
    return new Promise((resolve, reject) => {
      const deviceInfo = {
        appBundleId: {api: Advertising.appBundleId, responseType: 'string'},
        audio: {api: Device.audio, responseType: 'json'},
        distributor: {api: Device.distributor, responseType: 'string'},
        hdcp: {api: Device.hdcp, responseType: 'json'},
        hdr: {api: Device.hdr, responseType: 'json'},
        id: {api: Device.id, responseType: 'string'},
        make: {api: Device.make, responseType: 'string'},
        model: {api: Device.model, responseType: 'string'},
        name: {api: Device.name, responseType: 'string'},
        network: {api: Device.network, responseType: 'json'},
        platform: {api: Device.platform, responseType: 'string'},
        screenResolution: {api: Device.screenResolution, responseType: 'array'},
        sku: {api: Device.sku, responseType: 'string'},
        type: {api: Device.type, responseType: 'string'},
        uid: {api: Device.uid, responseType: 'string'},
        videoResolution: {api: Device.videoResolution, responseType: 'array'},
        version: {api: Device.version, responseType: 'json'}
      }

      const results:Promise<string> = []
      for (const [key, value] of Object.entries(deviceInfo)) {
        results.push(this.getDeviceApi(key, value.api, value.responseType))
      }
      Promise.all(results).then(dataList=>{
        const results  = dataList.join('&')
        Logger.processUserAction('deviceInfo', encodeURIComponent(results))
        resolve(true)
      })
    })
  }

  override getOptionsIconPath() {
    const { appConfig } = AppData as AppSetup
    if (appConfig?.platform_id == PLATFORM.PLATCO) {
      return Utils.asset('/images/option_0.png')
    }
    return Utils.asset('/images/option_i.png')
  }

  override async getPlatformDeeplinkData(): Promise<string> {
    return new Promise((resolve, reject) => {
      let playIdFromQuery: any = Helper.urlParam('playId', location.search);
      let playIdFromParams = ''
      let isValidDeeplinkParams = false
      let navigationAssetId = ''
      if (this._params && this._params.discovery && this._params.discovery.navigateTo && this._params.discovery.navigateTo) {
        try {
          const navigationIntent: Parameters.PlaybackIntent = this._params.discovery.navigateTo as Parameters.PlaybackIntent
          if (navigationIntent.data && navigationIntent.data.assetId && navigationIntent.data.assetId !== '') {
            isValidDeeplinkParams = true
            navigationAssetId = navigationIntent.data.assetId!
          }
          else {
            isValidDeeplinkParams = false
          }
        } catch (error) {

        }
      }
      if (isValidDeeplinkParams) {
        playIdFromParams = navigationAssetId
        Logger.processUserAction('deeplinkRawDataFromPlatform', JSON.stringify(this._params))
        Log.info('DeeplinkRawDataFromPlatform:', this._params)
        resolve(`?playId=${playIdFromParams}&src=hs-search`)
      } else if (!Helper.isEmpty(playIdFromQuery)) {
        Logger.processUserAction('deeplinkRawDataFromQueryString', playIdFromQuery)
        Log.info('DeeplinkRawDataFromQueryString:', playIdFromQuery)
        // fallback to the query string
        resolve(`?playId=${playIdFromQuery}&src=hs-search`)
      } else {
        resolve('')
      }
    })
  }

  _setupLifecycleEvents(): void {
    try {
      this.lifecycleListinerId = Lifecycle.listen((event: any, value: any) => {
        Log.info('PlatformBase: Lifecycle Events: ', event, value)
        Logger.processUserAction('LifecycleEvent', value.state)
        if (value.state === 'foreground') {
        } else if (value.state === 'inactive') {
          const currentRoute: string = Router.getActiveRoute()?.split('/')[0]!
          if (currentRoute == 'video-screen') {
            const page = Router.getActivePage()
            if (page && page.handleInactiveEvent) {
              page.handleInactiveEvent()!;
            }
          }
        }
      })
    } catch (error) {
      Log.error("Lifecycle.listen ", error)
    }

  }

  _setUpNavigationIntent(): void {
    // try {
    //   Discovery.listen('navigateTo', value => {
    //     Log.info('PlatformBase: NavigarionIntent: ', value)
    //   })
    // } catch (error) {
    //   Log.error("Discovery.listen ", error)
    // }

  }


  override getAppStoreId(indexObj: any): string {
    const { appConfig, platform, appState } = AppData as AppSetup;        
		const app = appState?.getApp();
    const appApiConfig = app?.appApiConfig;
		const adHandler = app.adHandler;
    return adHandler.getBundleId()
    /*if (indexObj && indexObj?.vizioAppId) return indexObj?.vizioAppId
    return ''*/
  }

  override async sendMetrics(eventType: string, dataObj: any): Promise<any> {
    Log.info('Send Metrics:', eventType, dataObj)
    switch (eventType) {
      case 'launch':
        try {
          const state = await Lifecycle.state()
          const page = Router.getActivePage()
          Log.info('PlatformBase: Lifecycle state', state)
          if (state == 'initializing') {
            Lifecycle.ready()
            return
          }
        } catch (error) {
          Log.error("Lifecycle.state ", error)
        }

        break;
      case 'close':
        try {
          Lifecycle.close(dataObj.reason)
          return
        } catch (error) {
          Log.error("Lifecycle.close ", error)
        }
        break;
      case 'startContent':
        try {
          Metrics.startContent(dataObj.vodInfo.node_id)
          return;
        } catch (e) {

        }
        //return Metrics.startContent(dataObj.vodInfo.node_id)
        break;
      case 'stopContent':
        const progress = parseFloat((dataObj.watchedDuration / dataObj.totalDuration).toFixed(3));
        try {
          await Discovery.watched(dataObj.vodInfo.node_id, progress, dataObj.completed)
          try {
            Metrics.stopContent(dataObj.vodInfo.node_id)
            return
          } catch (error) {
            Log.error("Metrics.stopContent ", error)
          }
        } catch (error) {
          Log.error("Discovery.watched ", error)
        }

        //return Metrics.stopContent(dataObj.vodInfo.node_id)
        break
      case 'error':
        try {
          Metrics.error(dataObj.errorType, dataObj.code, dataObj.description, false)
          return
        } catch (e) {
          Log.error("Metrics.error ", error)
        }
        //return Metrics.error(dataObj.errorType, dataObj.code, dataObj.description, false)
        break
    }

    // Lifecycle.ready()
    // .then(result => {
    //   Log.info('FIREBOLT >>> app ready lifecycle event sent', result)
    // })
  }

  override async getAdConfig(options: any) {
    Log.info('Ad Config : options ', options)
    if (this.adFrameworkConfig) {
      return this.adFrameworkConfig;
    }
    try {
      const adFrameworkConfig = await Advertising.config(options)
      this.adFrameworkConfig = adFrameworkConfig;
      Log.info('Ad Config : data ', this.adFrameworkConfig)
      return adFrameworkConfig;
    } catch (e) {
      //console.log("Advertising.config ",e)
      return null
    }
    /*.then(adFrameworkConfig => {
      resolve
     Log.info(adFrameworkConfig)
    })*/
  }

  override getMake(): string {
    return 'comcastXfinity'
  }
  
  override isOptionsKey(e: KeyboardEvent): boolean {
    if (Helper.getAppType() && Helper.getAppType().indexOf('platco') > -1) {
      if (e.code == 'Digit0') {
        return true
      }
    } else {
      return super.isOptionsKey(e)
    }
    return false
  }

  override getOptionsText() {
    if(Helper.getAppType().indexOf('platco') > -1) {
      return 'Press 0 for Options';
    } else {
      return super.getOptionsText()
    }
  }
}
